import Store from './modules/DataStore';
import { Actions } from './modules/DOM';
import { store } from './store/store';
import { addChannel as addChannelAction } from './store/channel/channelSlice';
import {
  clearSelectedPost,
  reloadPosts as reloadPostsAction,
  setSelectedPost,
  updateSelectedPost,
} from './store/post/postSlice';
import {
  addSubreddit as addSubredditAction,
  removeSubreddit as removeSubredditAction,
} from './store/subreddit/subredditSlice';
import { setSelection } from './store/subscription/subscriptionSlice';
import {
  setPreferences,
  toggleBigThumbnails as toggleBigThumbnailsAction,
  toggleExpandedReplies as toggleExpandedRepliesAction,
} from './store/preferences/preferencesSlice';
import {
  closeModal as closeModalAction,
  setGalleryImages,
  setMessage,
  setShowingChannelCreator,
  setShowingSubredditAdder,
} from './store/overlay/overlaySlice';
import { setMainViewToPosts } from './store/ui/uiSlice';

export function openPost({ post, transition = false }) {
  store.dispatch(setSelectedPost(post));
  Actions.toggleMenu(false);
  Actions.showDetailsView(Actions.scrollToTopOfDetailView, transition);
}

export function closePost({ transition = false } = {}) {
  closeModal();
  Actions.showPostsView(() => store.dispatch(clearSelectedPost()), transition);
}

export function savePost(reddit, postID) {
  return reddit
    .getSubmission(postID)
    .save()
    .then(() => {
      store.dispatch(updateSelectedPost({ saved: true }));
    })
    .catch(error => {
      showMessage(`Error while saving post: ${error}`);
    });
}

export function unsavePost(reddit, postId) {
  return reddit
    .getSubmission(postId)
    .unsave()
    .then(() => {
      store.dispatch(updateSelectedPost({ saved: false }));
    })
    .catch(error => {
      showMessage(`Error while unsaving post: ${error}`);
      console.error('Error while unsaving post', error);
    });
}

export function switchSubscription(newSelection) {
  store.dispatch(setSelection(newSelection));
  store.dispatch(setMainViewToPosts());
  Actions.showPostsView();
  Actions.toggleMenu(false);
}

export function openSubreddit(subredditName) {
  store.dispatch(setSelection({ type: 'subreddit', name: subredditName }));
  store.dispatch(setMainViewToPosts());
  Actions.showPostsView();
  Actions.toggleMenu(false);
}

export function signOut() {
  Store.clear();
  window.location = '';
}

export function showMessage(text, type = 'error', duration = 5000) {
  store.dispatch(setMessage({ text, type, duration }));
}

export function toggleMenu(expanded) {
  Actions.toggleMenu(expanded);
}

export function toggleExpandedReplies() {
  store.dispatch(toggleExpandedRepliesAction());
}

export function toggleBigThumbnails() {
  store.dispatch(toggleBigThumbnailsAction());
}

export function updatePreferences(preferences) {
  store.dispatch(setPreferences(preferences));
}

export function openSubredditSearcher() {
  store.dispatch(setShowingSubredditAdder(true));
}

export function openChannelCreator() {
  store.dispatch(setShowingChannelCreator(true));
  Actions.toggleMenu(false);
}

export function closeModal() {
  store.dispatch(closeModalAction());
}

export function reloadPosts() {
  store.dispatch(reloadPostsAction());
}

export function openImageGallery(images) {
  store.dispatch(setGalleryImages(images));
}

export function addSubreddit(subreddit) {
  store.dispatch(addSubredditAction(subreddit));
}

export function removeSubreddit(subreddit) {
  store.dispatch(removeSubredditAction(subreddit));
}

export function addChannel(channel) {
  store.dispatch(addChannelAction(channel));
}

export function votePost(reddit, { postId, dir }) {
  return reddit
    .oauthRequest({
      uri: '/api/vote',
      method: 'post',
      form: { dir, id: `t3_${postId}` },
    })
    .then(() => {
      store.dispatch(updateSelectedPost({ likes: dir === 0 ? null : dir > 0 }));
    })
    .catch(error => {
      showMessage(`Error while voting post: ${error}`);
      console.error('Error while voting post', error);
    });
}
